import useTranslation from 'next-translate/useTranslation';

import { classNames } from '@/utils';

interface UnsupportedMessageProps {
    isSent?: boolean;
}

export const UnsupportedMessage = ({ isSent }: UnsupportedMessageProps) => {
    const { t } = useTranslation('conversations');

    return (
        <div className={classNames('mb-2 flex', isSent ? 'justify-end' : 'justify-start')}>
            <div
                className={classNames(
                    'max-w-xs rounded-lg bg-icoGray-100 p-4 text-xs',
                    isSent ? 'bg-icoBlue text-white' : 'bg-icoGray-100 text-icoBlack'
                )}>
                <h4>{t('direct_messages.unsupported_media')}</h4>
                <p className={classNames('mt-1', isSent ? 'text-white' : 'text-icoGray-500')}>
                    {t('direct_messages.use_instagram_app')}
                </p>
            </div>
        </div>
    );
};
